import { useEffect, useRef } from "react";
import { resolveReturnOnce } from "../utils/bankIdSession";

/**
 * Runs `onResult(result)` once the page's BankID return (if any) has been resolved — on mount,
 * and again when the BankID app brings an already open tab back with a new "#bankid-state=…"
 * (no reload). `result` is null when the page was not opened by a return; the callback should
 * then still look for a pending operation (reload while an order runs). Callbacks must be
 * idempotent: they can run more than once for the same result.
 */
export function useBankIdReturn(onResult, enabled = true) {
  const callback = useRef(onResult);
  callback.current = onResult;

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const run = () => {
      resolveReturnOnce().then((result) => {
        if (alive) callback.current?.(result);
      });
    };
    run();
    window.addEventListener("hashchange", run);
    return () => {
      alive = false;
      window.removeEventListener("hashchange", run);
    };
  }, [enabled]);
}
